import { type AMLabsProduct } from '../model/product';

export const getPrice = (product: AMLabsProduct): number =>
  product.specialPrice ?? product.defaultPrice;
